import { __awaiter } from "tslib";
import React from 'react';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import ReactDOM from 'react-dom';
import isMobile from 'utils/isMobile';
import { AddToMyFandomsNotificationModule } from 'pathfinder/modules/AddToMyFandomsNotification/AddToMyFandomsNotificationModule';
import { isNotificationBanner } from 'pathfinder/modules/MarketingNotifications/utils/checkBannerNotification';
import { getVisitsWithinTimeFrame, getWikiVisitCount, hasCurrentWikiInMyFandoms } from './utils/fandomsStorage';
import { ADD_TO_MY_FANDOMS_MODULES_VARIANTS, } from 'pathfinder/rules-engine/modules/addToMyFandomsNotification';
import { getCookieByName } from 'utils/getCookieByName';
import getOptimizelyVariant from 'pathfinder/utils/getOptimizelyVariant';
import { ADD_TO_MY_FANDOMS_OPTIMIZELY_VARIABLES } from 'pathfinder/modules/AddToMyFandomsNotification/types';
export const getAddToMyFandomsNotificationModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const isForced = (_a = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.internalState) === null || _a === void 0 ? void 0 : _a.forced;
    const isMobileDevice = Boolean(isMobile());
    const moduleProps = buildModuleProps(moduleConfig, {
        isMobile: isMobileDevice,
        moduleName: moduleConfig.type,
    });
    const { log } = moduleProps;
    try {
        // TODO: remove similar logic from MarketingNotifications
        const variant = yield getOptimizelyVariant(isForced, ADD_TO_MY_FANDOMS_OPTIMIZELY_VARIABLES, ADD_TO_MY_FANDOMS_MODULES_VARIANTS);
        if (!variant) {
            log.debug('Not displayed due to no variant (Optimizely experiment is disabled)');
            return;
        }
        // if we're not this variant, just bail
        if (variant !== moduleConfig.name) {
            log.debug('Not displayed due to variant mismatch (this variant is not enabled)');
            return;
        }
        const hasNotificationsDisabled = window.mw.config.get('wgDisableCMSNotifications');
        if (hasNotificationsDisabled) {
            log.debug('Not displayed due to disable notification flag');
            return null;
        }
        const isBannerNotificationVisible = isNotificationBanner();
        if (isBannerNotificationVisible) {
            log.debug('Not displayed due to banner notification not visible');
            return null;
        }
        const alreadyInFandoms = yield hasCurrentWikiInMyFandoms();
        if (alreadyInFandoms) {
            log.debug('Not displayed due to already in fandoms');
            return null;
        }
        // check this only if not forced
        if (!isForced) {
            const displayOnVisit = moduleConfig.config.displayOnVisit;
            switch (variant) {
                case ADD_TO_MY_FANDOMS_MODULES_VARIANTS.FIRST_VISIT: {
                    const visitCount = yield getWikiVisitCount();
                    if (visitCount != displayOnVisit) {
                        log.debug('Not displayed due to visitCount', {
                            visitCount,
                            displayOnVisit,
                        });
                        return null;
                    }
                    break;
                }
                case ADD_TO_MY_FANDOMS_MODULES_VARIANTS.ONE_WEEK: {
                    const visitsWithinTimeFrame = getVisitsWithinTimeFrame(moduleConfig.config.visitsWithinTime);
                    if (visitsWithinTimeFrame != displayOnVisit) {
                        log.debug('Not displayed due to visitsWithinTimeFrame', {
                            visitsWithinTimeFrame,
                            displayOnVisit,
                        });
                        return null;
                    }
                    break;
                }
                default: {
                    log.debug('Not displayed due to unknown variant', variant);
                    return null;
                }
            }
        }
        else {
            log.debug('Forced module, skipping checking variant conditions');
        }
        const NOTIFICATION_COOKIE_NAME = 'add_to_my_fandoms_notification';
        const hasShownNotification = JSON.parse(getCookieByName(NOTIFICATION_COOKIE_NAME)) || [];
        const { current } = window.SilverSurferSDK.getContext();
        const wikiId = current.productId;
        // if (hasShownNotification?.includes(wikiId)) {
        // 	log.debug('Not displayed due to having been shown already');
        // 	return null;
        // }
        const notificationsContainer = isMobileDevice
            ? document.querySelector('.notifications-box')
            : document.querySelector('.notifications-placeholder');
        const hasFeatureVideo = !!document.querySelector('#article-featured-video-container');
        if (!notificationsContainer) {
            log.debug('Not displayed due to missing notifications container');
            return null;
        }
        const reactRoot = document.createElement('div');
        reactRoot.classList.add('add-to-my-fandoms-notification');
        if (hasFeatureVideo && isMobileDevice) {
            reactRoot.style.position = 'fixed';
            reactRoot.style.bottom = '0';
            reactRoot.style.width = '100%';
        }
        reactRoot.style.overflowY = isMobileDevice ? 'hidden' : 'none';
        notificationsContainer.insertAdjacentElement('afterbegin', reactRoot);
        hasShownNotification.push(wikiId);
        // Ignoring cookie restriction for experiment
        // eslint-disable-next-line
        document.cookie = `${NOTIFICATION_COOKIE_NAME}=${JSON.stringify(hasShownNotification)};path=/;domain=.fandom.com;max-age=1704085200`;
        const render = () => {
            ReactDOM.render(React.createElement(AddToMyFandomsNotificationModule, moduleProps), reactRoot);
            return reactRoot;
        };
        return {
            render,
        };
    }
    catch (error) {
        log.error('AddToMyFandoms error', error);
    }
    return null;
});
